"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMockUtilityTerm = void 0;
var makeMockTerm_1 = require("./makeMockTerm.js");
var mockUtilityForType_1 = require("./mockUtilityForType.js");
function makeMockUtilityTerm(t) {
    return ((0, mockUtilityForType_1.mockUtilityForType)(t)((0, makeMockTerm_1.makeMockTerm)(t)));
}
exports.makeMockUtilityTerm = makeMockUtilityTerm;
